import React, { useState, useRef } from 'react';
import { FormControl, Select, Checkbox, TableHead, Link, MenuItem, Paper, Popover, Stack, Table, TableBody, TableCell, TableContainer, TextField, TableRow, Typography, Card, CardContent, Grid } from '@mui/material'
import { useEffect } from 'react';
import FileCopyIcon from '@mui/icons-material/FileCopy';

export const DemandReports = () => {
  return (
    <Grid container spacing={1} >
        <Grid container>
          <Grid item xs={0} lg={4}></Grid>
          <Grid item xs={12} lg={4} spacing={1}>
            <Stack direction='column' style={{ justifyContent: 'center', alignItems: 'center' }}>
              <FileCopyIcon color="disabled" sx={{ fontSize: 70 }} />
              <Typography variant="h4" color="gray">No Reports</Typography>
            </Stack>
          </Grid>
          <Grid item xs={0} lg={4}></Grid>
        </Grid>
    </Grid >
  )
}